/* eslint-disable no-extend-native */

import moment, { Moment } from "moment";

declare global {
	interface String {
		toMonentWS(): Moment;
		toMomentFormat(format: string): Moment;

		toDateWS(): Date;
		toDateFormat(format: string): Date;
		format(...args: any[]): string;

		toFormattedDateString(format: string): string;
		isNullOrWhiteSpaces(): boolean;
	}
}
const dateWSPattern: string = "YYYY-MM-DDTHH:mm:ss";

String.prototype.toMonentWS = function (): Moment {
	let str = this.toString();
	return str.toMomentFormat(dateWSPattern);
};

String.prototype.toMomentFormat = function (format: string): Moment {
	let str = this.toString();
	return moment(str, format);
};

String.prototype.toDateWS = function (): Date {
	return this.toMonentWS().toDate();
};

String.prototype.toDateFormat = function (format: string): Date {
	return this.toMomentFormat(format).toDate();
};
String.prototype.toFormattedDateString = function (format: string): string {
	return this.toDateWS().toFormattedDateString(format);
};

String.prototype.format = function (...args) {
	return this.replace(/{([0-9]+)}/g, function (match, index) {
		// check if the argument is there
		return typeof args[index] == "undefined" ? match : args[index];
	});
};


String.prototype.isNullOrWhiteSpaces = function (): boolean {
	return !this || this.trim() === "";
};
export {};
